<template>
  <DpplHeaderFooterContent class="right-sidebar">
    <template
      v-if="currentTab !== 'flsa' && currentTab !== 'approvals'"
      #header
    >
      <div class="px-6 py-4 border-b-sm">
        <h2 class="text-h2">
          {{ tabTitle }}
        </h2>
      </div>
    </template>

    <div
      v-if="currentTab === 'template-usage'"
      class="w-100"
    >
      <TemplateUsage />
    </div>

    <div
      v-if="currentTab === 'flsa'"
      class="w-100"
    >
      <FlsaPanel />
    </div>

    <div
      v-if="currentTab === 'approvals'"
      class="w-100"
    >
      <ApprovalsPanel />
    </div>

    <div
      v-if="currentTab === 'history'"
      class="w-100"
    >
      <RevisionsContainer />
    </div>

    <div
      v-if="currentTab === 'access-list'"
      class="w-100"
    >
      <AccessListSidebar />
    </div>

    <div
      v-if="currentTab === 'compare-jobs'"
      class="w-100 h-100 overflow-hidden d-flex flex-column"
    >
      <CompareJobsPanel />
    </div>

    <!-- render sidebar invisible to load cord and check if there's any comments -->
    <CommentsSidebar
      :class="[currentTab === 'comments' ? 'w-100' : 'w-0']"
      :page-id="route?.params?.id"
      :page-name="route?.name"
      :page-title="jobProfile?.title"
      @comment-added="handleCommentAdded"
    />
  </DpplHeaderFooterContent>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppRoute } from '@/stores/app/route';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';
import { useTracking } from '@/stores/tracking/tracking';
import CommentsSidebar from '@/components/document/comments/CommentsSidebar.vue';
import FlsaPanel from '@/components/jobProfiles/editor/FlsaPanel.vue';
import ApprovalsPanel from '@/components/jobProfiles/editor/ApprovalsPanel.vue';
import RevisionsContainer from '@/components/jobProfiles/editor/RevisionsContainer.vue';
import TemplateUsage from '@/components/jobProfiles/editor/TemplateUsage.vue';
import AccessListSidebar from '@/components/document/rightPanel/AccessListSidebar.vue';
import CompareJobsPanel from '@/components/jobProfiles/editor/CompareJobsPanel.vue';
import DpplHeaderFooterContent from '@ui/components/general/DpplHeaderFooterContent/DpplHeaderFooterContent.vue';

const { route } = storeToRefs(useAppRoute());
const { jobProfile, isHrisProfile } = storeToRefs(useCurrentJobProfile());
const rightPanelStore = useDocumentRightPanel();
const { currentTab } = storeToRefs(rightPanelStore);

const tabTitle = computed(() => ({
  history: isHrisProfile.value ? 'Version history' : 'Revision history',
  'template-usage': 'Template used by',
  'access-list': 'Access list',
  'compare-jobs': 'Compare Jobs',
}[currentTab.value] ?? 'Comments'));

const handleCommentAdded = () => {
  useTracking().jpEditorAddedComment();
};
</script>
